var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('display-tag-images',{ref:"imageDisplay",staticClass:"mb-6",attrs:{"tag-id":_vm.tagId}}),_c('upload-tag-images',{attrs:{"tag-id":_vm.tagId},on:{"uploaded":_vm.onImagesUploaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }